"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FullContactPersonModel {
    static fromDatabase(dbObject) {
        return new FullContactPersonModel({
            _id: dbObject.phone ? dbObject.phone : dbObject.email,
            apiResult: dbObject.apiResult,
            createdAt: dbObject.created_at,
            updatedAt: dbObject.updated_at
        });
    }
    constructor(json) {
        Object.keys(json).forEach((key) => {
            this[key] = json[key];
        });
    }
}
exports.FullContactPersonModel = FullContactPersonModel;
//# sourceMappingURL=full-contact-person.model.js.map